import { CurecallConfirmationModal } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { UserProjectService } from 'src/services/user-project.service'
import { useQueryClient } from '@tanstack/react-query'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { useNotification } from 'src/providers/notification.provider'
import { getErrorMessage } from 'src/utils/http.util'
import { TUserProject } from 'src/types/user'

interface UsersModalProps {
  modalProps: any
  setModalProps: any
}
export default function DeleteUserModal({ modalProps, setModalProps }: UsersModalProps) {
  const { t } = useTranslation()
  const { project } = useCurrentProject()
  const queryClient = useQueryClient()
  const { notify } = useNotification()

  const onDelete = async () => {
    const userToDeleteId = modalProps?.UserProject?.UserId
    if (!userToDeleteId) return
    try {
      await UserProjectService.deleteUserProject(project.id, userToDeleteId)
      setModalProps(undefined)
      queryClient.setQueryData(['user-project-list'], (oldData: Array<TUserProject> | undefined) =>
        oldData?.filter((oldUserProject) => {
          return oldUserProject.UserId !== userToDeleteId
        }),
      )
    } catch (error) {
      notify(
        {
          title: t('common.error.generic'),
          message: getErrorMessage(error),
          appearance: 'SUCCESS',
        },
        15000,
      )
    }
  }

  return (
    <CurecallConfirmationModal
      title={t('pages.users-page.delete-title')}
      isOpen={modalProps?.mode === 'DELETE'}
      onCancel={() => setModalProps(undefined)}
      onConfirm={onDelete}
      cancelButtonLabel={t('pages.users-page.cta-cancel')}
      confirmButtonLabel={t('pages.users-page.cta-delete')}
      color="ALERT"
    >
      <div className="c-text-lg c-font-bold">
        {modalProps?.mode === 'DELETE' &&
          `${modalProps.UserProject.User.title} ${modalProps.UserProject.User.firstname} ${modalProps.UserProject.User.lastname}`}
      </div>
    </CurecallConfirmationModal>
  )
}
